export default "__VITE_ASSET__CEu8Y1Mg__"